import { useRef, useState } from 'react'
import {
  Box
  , ClickAwayListener
  , Fade
  , IconButton
  , MenuItem
  , MenuList
  , Paper
  , Popper
  , useTheme
} from '@mui/material'
import LayersIcon from '@mui/icons-material/Layers'
import { maplibreGroupChildIconButtonSx } from '../../consts/map-floating-control-sx'

const positions = {
  'top-left'     : { top: 146, left: 10 }
  , 'top-right'    : { top: 146, right: 10 }
  , 'bottom-left'  : { bottom: 146, left: 10 }
  , 'bottom-right' : { bottom: 146, right: 10 }
}

export default function StylesControl ({ handleSetStyle, position, inToolbar = false }) {
  const theme = useTheme()
  const zIndex = theme.zIndex.drawer - 1
  const floatSx = maplibreGroupChildIconButtonSx(theme)
  const [open, setOpen] = useState(false)
  const buttonRef = useRef(null)
  const anchorEl = buttonRef.current
  // const [anchorEl, setAnchorEl] = useState(null)
  const [selectedIndex, setSelectedIndex] = useState(0)

  const handleClick = event => {
    // setAnchorEl(anchorEl ? null : event.currentTarget)
    setOpen(prevOpen => !prevOpen)
  }

  const canBeOpen = open && Boolean(anchorEl)
  const id = canBeOpen ? 'transition-popper' : undefined

  const mapStyles = [
    { name: 'Map', style: 'openstreetmap' }
    , { name: 'Urban', style: 'streets' }
    , { name: 'Satellite', style: 'satellite' }
    , { name: 'Hybrid', style: 'hybrid' }
  ]

  const iconButton = (
    <IconButton
      ref={buttonRef}
      type="button"
      className="fred-map-toolbar-btn"
      sx={[
        floatSx,
        inToolbar
          ? { position: 'relative' }
          : {},
        {
          WebkitTapHighlightColor: 'transparent',
          fontSize: '1.5rem',
          zIndex,
        },
      ]}
      aria-describedby={id}
      aria-controls={open ? 'split-button-menu' : undefined}
      aria-expanded={open ? 'true' : undefined}
      aria-label="select map layer"
      aria-haspopup="menu"
      disableRipple
      onClick={handleClick}
    >
      <LayersIcon style={{ color: 'black' }} fontSize="inherit" />
    </IconButton>
  )

  return (
    <>
      {inToolbar ? (
        iconButton
      ) : (
        <Box
          className="maplibregl-ctrl maplibregl-ctrl-group"
          sx={{ position: 'absolute', ...positions[position] }}
        >
          {iconButton}
        </Box>
      )}
      <Popper
        id={id}
        sx={{ zIndex }}
        open={open}
        anchorEl={anchorEl}
        role={undefined}
        transition
        placement='left'
        modifiers={[
          {
            name    : 'offset'
            , options : {
              offset: [0, 10]
            }
          }
        ]}
      >
        {({ TransitionProps }) => (
          <Fade
            {...TransitionProps}
            style={{
              transformOrigin: 'right'
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={() => setOpen(false)}>
                <MenuList id="popper-menu" autoFocusItem>
                  {mapStyles.map((style, index) => (
                    <MenuItem
                      key={style.style}
                      selected={index === selectedIndex}
                      onClick={() => {
                        setSelectedIndex(index)
                        handleSetStyle(mapStyles[index].style)
                        setOpen(false)
                      }}
                    >
                      {style.name}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
    </>
  )
}

/* WIP: Implementation that uses use control and custom control */
// import { useControl } from '@vis.gl/react-maplibre'
// import StylesControl from '@mapbox-controls/styles'
// import '@mapbox-controls/styles/src/index.css'

// const styles = [
//   {
//     label       : 'Streets'
//     , styleName : 'Maptiler streets'
//     , styleUrl  : `https://api.maptiler.com/maps/openstreetmap/style.json?key=${process.env.REACT_APP_API_KEY}`
//   }
//   , {
//     label       : 'Satellite'
//     , styleName : 'Maptiler satellite'
//     , styleUrl  : `https://api.maptiler.com/maps/satellite/style.json?key=${process.env.REACT_APP_API_KEY}`
//   }
// ]
// const mapStyles = [
//     { name: 'Map', style: 'openstreetmap' }
//     , { name: 'Urban', style: 'streets' }
//     , { name: 'Satellite', style: 'satellite' }
//     , { name: 'Hybrid', style: 'hybrid' }
//   ]
// {                 label: 'Streets'
//   , styleName : 'Mapbox Streets'
//   , styleUrl  : 'mapbox://styles/mapbox/streets-v12'
// }, {
//   label       : 'Satellite'
//   , styleName : 'Mapbox Satellite Streets'
//   , styleUrl  : 'mapbox://sprites/mapbox/satellite-streets-v12'
// }), 'top-left')

// or with compact view and default styles (streets and satellite)
// map.addControl(new StylesControl({ compact: true }), 'top-left')

// export default function StyleControl (props) {
//   useControl(() => new StylesControl({
//     styles
//     , compact: props.compact
//   }), {
//     position: props.position
//   })

//   return null
// }
